module.exports = __webpack_public_path__ + "static/media/NextArticle.056da41d.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/images/NextArticle.PNG
// module id = 1540
// module chunks = 1